
import React from 'react'
import PropTypes from 'prop-types'
import { Redirect, Route } from 'react-router-dom'


const ProtectedRoute = ({component: Component, grantAccess, passProps, redirectPath, ...rest}) => (
  <Route
    render={props => (
      grantAccess
      ? <Component
          {...passProps}
          {...props}
        />
      : <Redirect to={redirectPath}/>
    )}
    {...rest}
  />
)

ProtectedRoute.propTypes = {
  component: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.func // pure component
  ]).isRequired,
  data: PropTypes.object,
  grantAccess: PropTypes.bool.isRequired,
  path: PropTypes.string.isRequired,
  redirectPath: PropTypes.string.isRequired
}

export default ProtectedRoute



// WEBPACK FOOTER //
// ./src/components/routes/ProtectedRoute.js